module.exports = __webpack_public_path__ + "img/Access Bank.82c92ea2.png";